module.exports = __webpack_public_path__ + "static/img/banner-utbk.3213d58.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banners/banner-utbk.jpg
// module id = Hlw2
// module chunks = 1